'use client'

import { CheckboxMultiSelect } from '@components/primitives/HtmlForm/CheckboxMultiSelect.client'
import { Text } from '@components/primitives/Text'
import { RACE_ETHNICITY_OPTIONS } from '@lib/types/Identity'
import { debounceTrackQuestionModified } from './trackQuestionModified'
import type { DemographicsCollectElementProps } from './types'

const debouncedEventTracking = debounceTrackQuestionModified('ethnicIdentities')

export default function CollectRaceEthnicityIdentities({
  formRef,
  patientProfileData: { ethnicIdentities },
  questionConfig,
}: DemographicsCollectElementProps) {
  const handleInputChange = (newInputValue: string | string[]) => {
    debouncedEventTracking(newInputValue)
  }

  return (
    <div className='flex w-full flex-col gap-2'>
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='h3'
        value='Which races or ethnicities do you most identify with?'
      />
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='p-small'
        value='Why we ask: medical research has historically struggled with diversity. Help us change that!'
      />
      <div className='grid grid-cols-1 gap-2 md:grid-cols-2'>
        <CheckboxMultiSelect
          defaultValues={ethnicIdentities}
          formRef={formRef}
          name={questionConfig.id}
          onChange={handleInputChange}
          options={RACE_ETHNICITY_OPTIONS}
          required={!questionConfig.skippable}
        />
      </div>
    </div>
  )
}
